import { Layout, Row, Col } from 'antd'
import PageFooter from 'components/PageFooter'
import PageHeader from 'components/PageHeader'
import PropTypes from 'prop-types'
import { StyledGlobalLayout } from 'components/GlobalStyles'
import SearchBar from 'components/SearchBar'

const { Content } = Layout

export default function Index ({ children }) {
  return (
    <StyledGlobalLayout bg='/images/bg/standard-bg.png'>
      {/* hide nav on mobile  */}
      <Row>
        <Col xs={{ span: 0 }} md={{ span: 24 }}>
          <PageHeader />
        </Col>
      </Row>
      <SearchBar />
      <Content style={{ minHeight: '100vh' }}>
        {children({})}
      </Content>
      <PageFooter />
    </StyledGlobalLayout>
  )
}

Index.propTypes = {
  children: PropTypes.any
}
